import React from 'react';
import Icon from '../../../components/AppIcon';

const RankingPanel = ({ title, rankings, type = 'client', icon }) => {
  const formatValue = (value) => {
    if (type === 'client') {
      return `€${value?.toFixed(2)}`;
    }
    return value;
  };

  const getSubtitle = (item) => {
    if (type === 'client') {
      return `${item?.count || 0} loncheados`;
    }
    return `${item?.loncheadosCount || 0} loncheados - €${item?.totalSalary?.toFixed(2)}`;
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-md border border-border">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name={icon} size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg md:text-xl font-oranienbaum font-semibold text-foreground">
          {title}
        </h3>
      </div>

      {rankings && rankings?.length > 0 ? (
        <div className="space-y-3">
          {rankings?.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-3 bg-background rounded-lg border border-border hover:border-primary/50 transition-smooth"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                  <span className="text-sm font-oranienbaum font-semibold text-primary">
                    {index + 1}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base font-oranienbaum font-medium text-foreground truncate">
                    {item?.nombre}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {getSubtitle(item)}
                  </p>
                </div>
              </div>
              <div className="flex-shrink-0 ml-3">
                <p className="text-base md:text-lg font-oranienbaum font-semibold text-[#3A7F6B]">
                  {formatValue(type === 'client' ? item?.totalRevenue : item?.totalSalary)}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <p className="text-muted-foreground">No hay datos disponibles</p>
        </div>
      )}
    </div>
  );
};

export default RankingPanel;